module.exports = __webpack_public_path__ + "media/images/receipt/logo-bfe5456e9384ff16741748e6034b84e8.svg";